import { AppButton, AppTextField } from 'components';
import useToaster from 'hooks/useToaster';
import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import * as AppPics from 'assets/images';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import useChaptersQuizzes from 'hooks/API/GET/useChaptersQuizzes';
import useManageChapterQuiz from 'hooks/API/useManageChapterQuiz';
import DetailsHeader from 'components/molecules/DetailsHeader';
import useReOrderChapterQuiz from 'hooks/API/POST/useReOrderChapterQuiz';
import QuizListing from './QuizListing';

function MainChaptersQuiz() {
  const { courseID } = useParams();
  const [tab, setTab] = useState('quiz');
  const [quizName, setQuizName] = useState('');
  const [selectedChapter, handleSelectedChapter] = useState({});
  const [status, handleStatus] = useState('active');
  const [formErrors, setFormErrors] = useState([]);
  const [chapters, setChapters] = useState([]);

  const _chapters = useChaptersQuizzes({ enabled: true, courseID });
  const { data, isLoading: isListing, isError: isListingError } = _chapters;
  const { mutate, isLoading, isError } = useManageChapterQuiz({ courseID });
  const _reorder = useReOrderChapterQuiz({ courseID });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  useEffect(() => {
    if (data?.data?.length > 0) {
      setChapters(
        [].concat(data?.data).map((chapter) => {
          if (Array.isArray(chapter.quizzes)) {
            chapter.quizzes = chapter.quizzes.map((quiz) => {
              quiz.id = quiz._id;
              return quiz;
            });
          }
          return chapter;
        })
      );
    }
  }, [data?.data]);

  function manageQuiz(body = {}) {
    if (!quizName) return;
    if (isLoading) return;

    const data = { name: `${quizName}`.trim(), ...body, status, quizType: tab };

    const validation = manageQuizSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    mutate(data);
    clearData();
  }

  function clearData() {
    setFormErrors([]);

    setQuizName('');
    handleStatus('active');
    // handleSelectedChapter({});
  }

  function handleReOrder(chapterID) {
    if (_reorder.isLoading) return;

    const selectedChapter = chapters.find((chapter) => chapter._id === chapterID);
    if (selectedChapter) {
      const quizzes = selectedChapter?.quizzes?.filter?.((x) => x.quizType === tab) || [];
      const quizIds = quizzes.map((x) => x._id);
      _reorder.mutate({ chapterID, quizIds });
    }
  }

  const errors = checkForErrors(formErrors);

  return (
    <>
      <div className="mainWraper">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <Link to={`/courses/${courseID}/edit`}>
                <AppButton variantClass="btn-back">
                  <img src={AppPics.BackSvg} alt="" />
                </AppButton>
              </Link>
            </li>
            <li className={`${tab === 'quiz' ? 'active' : ''}`} onClick={() => setTab('quiz')}>
              Quiz
            </li>
            <li className={`${tab === 'ncert' ? 'active' : ''}`} onClick={() => setTab('ncert')}>
              NCERT Answered
            </li>
            <li
              className={`${tab === 'previous_year' ? 'active' : ''}`}
              onClick={() => setTab('previous_year')}
            >
              Previous Year Questions
            </li>
          </ul>

          <div className="tab__content">
            {/* START: 1 */}
            <div className="tab__content-actHead">
              <DetailsHeader />
            </div>
            {/* END: 1 */}

            <div className="tab__content-actBody">
              <div className="px-5">
                {isListing ? (
                  'Loading...'
                ) : isListingError ? (
                  'Failed to load data'
                ) : (
                  <>
                    {chapters.map((item) => {
                      return (
                        <div className="row mt-5" key={item._id}>
                          <div className="col-12">
                            <div className="saved lessonWrap--border p-0">
                              <div className="row bgltgreen level1">
                                <div className="col-md-10 col-lg-10 col-sm-12">
                                  <div className="lessonWrap saved lessonWrap--border">
                                    <div className="lessonWrap__text">
                                      <span className="lessonWrap__name">{item.name}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-2 col-lg-2 col-sm-12 mt-2 my-auto _pcetnteefid">
                                  <AppButton
                                    variantClass="btn-plane p--tint m-l-btn"
                                    onClick={() => handleSelectedChapter(item)}
                                  >
                                    + Quiz
                                  </AppButton>
                                </div>
                              </div>
                              {/* BEGIN: Quiz name input section */}
                              {selectedChapter?._id === item._id && (
                                <div className="row m-4">
                                  <div className="col-md-10 col-lg-10 col-sm-12">
                                    <div className="lessonWrap lessonWrap--border formfield">
                                      <AppTextField
                                        labelProps={{ label: 'Quiz Name' }}
                                        inputProps={{
                                          placeholder: 'Please provide quiz name here...',
                                          value: quizName,
                                          onChange: (event) => setQuizName(event.target.value),
                                        }}
                                        fieldErrors={errors['name']}
                                      />
                                      <div>
                                        <AppButton
                                          variantClass="btn-plane p--tint my-4"
                                          onClick={() => manageQuiz({ chapterID: item._id })}
                                        >
                                          Save
                                        </AppButton>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* END: Quiz name input section */}

                              {true && (
                                <QuizListing
                                  courseID={courseID}
                                  chapterID={item._id}
                                  quizzes={item?.quizzes?.filter?.((x) => x.quizType === tab)}
                                  setList={(newState) => {
                                    const __Chapters = chapters.map((x) => {
                                      if (item._id === x._id) {
                                        if (Array.isArray(x.quizzes)) {
                                          const filteredQuizzes = x.quizzes.filter(
                                            (quiz) => quiz.quizType !== tab
                                          );
                                          x.quizzes = filteredQuizzes.concat(newState);
                                        }
                                      }
                                      return x;
                                    });
                                    setChapters(__Chapters);
                                  }}
                                  handleSort={(chapterID) => handleReOrder(chapterID)}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const manageQuizSchema = Joi.object({
  name: Joi.string().required().trim(),
});

export default MainChaptersQuiz;
